var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"dense":"","headers":[
    { text: 'Abreviación', value: 'abbreviation' },
    { text: 'Nombre', value: 'name' },
    { text: 'Codigo', value: 'code' }
  ],"sort-by":"name","items":_vm.amenities,"items-per-page":10},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('span',{staticClass:"text-h6 grey--text"},[_vm._v(" Amenidades ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }